import { createStore } from '@stencil/store';

import { HistoryIcon } from '../interfaces/interface.consumer-market-confidence';
import { AutoCheckData } from '../interfaces/interface.vehicle';

type AutoCheckState = typeof initialState;

const initialState: AutoCheckData = {
  autoCheckFullReportLink: '#',
  hasAccidents: false,
  hasFloodDamage: false,
  hasFrameDamage: false,
  hasSingleOwner: false,
  hasPriorRentals: false,
  hasBeenToAuction: false,
  reportDate: '',
  isAutocheckAuctionEligible: false,
  verifiedMileage: 0,
  titleBrand: false,
  isSalvage: false,
  notActualMileage: false,
  previouslyCanadian: false,
  autoCheckDataJSON: '',
  historyIcons: [] as HistoryIcon[],
};

const { on, onChange, state, reset } = createStore(initialState);

export { initialState, on, onChange, state, reset, AutoCheckState };
export default state;
